/* 通知管理 */
import request from '../utils/request'
import Mock from 'mockjs'

/* 获取促销活动通知 */
export const getPromotionAPI = data => {
    return request({
        url: '/promotion/list',
        method: 'get',
        data
    })
}

/* 标记已读促销活动通知 */
export const markReadPromotionAPI = data => {
    return request({
        url: '/notice/markReadPromotion',
        method: 'post',
        data,
    })
}

/* 获取促销活动通知个项详情 */
export const getPromotionItemAPI = id => {
    return request({
        url: '/promotion/detail',
        method: 'get',
        data: { id: id }
    })
}

/* 获取充值活动通知 */
export const getRechargeAPI = data => {
    const result = Mock.mock({
        'list|10': [{
            'id|+1': 1,
            title: '@title(10, 20)',
            amount: () => `$ ${Mock.mock('@float(100, 1000, 2, 2)')}`,
            isRead: '@boolean',
            date: '@datetime("yyyy-MM-dd HH:mm:ss")',
        }, ],
        total: 400,
    })
    return result
        // return request({
        // 	url: '/notice/getRecharge',
        // 	method: 'post',
        // 	data,
        // })
}

/* 标记已读充值活动通知 */
export const markReadRechargeAPI = data => {
        return request({
            url: '/notice/markReadRecharge',
            method: 'post',
            data,
        })
    }
    /* 获取邀请用户列表接口 */
export const getNoticeInvitations = params => {
        return request({
            url: '/user_notice/invitations',
            method: 'get',
            data: params,
        })
    }
    /* 获取邀请用户列表接口 */
export const respondToInvitation = params => {
    return request({
        url: '/user_notice/respond_to_invitation',
        method: 'post',
        data: params,
    })
}


/* 获取通知列表 */
export const getNoticeListAPI = data => {
    return request({
        url: '/user_notice/notices',
        method: 'get',
        data
    })
}

/* 获取通知详情 */
export const getNoticeDetailAPI = id => {
    return request({
        url: '/user_notice/detail',
        method: 'get',
        data: { id }
    })
}